import { render, staticRenderFns } from "./SensitiveKeywordsList.vue?vue&type=template&id=b384620e&scoped=true"
import script from "./SensitiveKeywordsList.vue?vue&type=script&lang=js"
export * from "./SensitiveKeywordsList.vue?vue&type=script&lang=js"
import style0 from "./SensitiveKeywordsList.vue?vue&type=style&index=0&id=b384620e&prod&lang=scss&scoped=true"
import style1 from "./SensitiveKeywordsList.vue?vue&type=style&index=1&id=b384620e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b384620e",
  null
  
)

export default component.exports